import { Box, Typography } from '@mui/material';
import TypeText from '../../../form/form-fields/TypeText';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';

export const MatchingPropLeadFieldText = ({ property, onChange }) => {
  const { t } = useTranslation();

  const valueField = {
    label: property.label,
    key: 'minValue',
  };

  function handleUpdate(key, value) {
    const newProp = { ...property, [key]: value };
    onChange(newProp);
  }

  return (
    <TypeText
      size="small"
      field={valueField}
      dataCollection={property}
      updateValidationOnChange={handleUpdate}
    />
  );
};
